<template>
    <div id="app">
        <div class="banner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="text-left"><div class="float-left"><a href="https://mamela.co.za"><img src="mamela_logo.png" height="80" hspace="20"/></a></div>
                            <div class="banner-txt">Investor Portfolio Login</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <br/>
        <br/>
        <tenants-page v-if="tenantsShowProp" @log_out="log_out" :login-data="this.loginData"></tenants-page>
        <login-page v-show="loginShowProp" @login_success="loginSuccess"></login-page>
        <br/>
        <br/>
        <div class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="text-right">
                            Powered by <a href="http://www.powerprop.co.za/" target="_blank">PowerProp Systems</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import 'bootstrap/dist/css/bootstrap.css';
    import 'bootstrap-vue/dist/bootstrap-vue.css';
    // import {Layout} from 'bootstrap-vue/es/components';
    import './_app.scss';
    import LoginPage from "./components/LoginPage/LoginPage";
    import TenantsPage from "./components/TenantsPage/TenantsPage";
    import {ClientTable} from 'vue-tables-2';

    // Vue.use(Layout);
    Vue.use(BootstrapVue);
    Vue.use(ClientTable);

    export default {
        name: 'app',
        props: {
            loginShow: {
                type: Boolean,
                default: true
            },
            tenantsShow: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                loginShowProp: this.loginShow,
                tenantsShowProp: this.tenantsShow,
                loginData: {}
            }
        },
        components: {
            TenantsPage,
            LoginPage,
        },

        methods: {
            log_out() {
                this.loginShowProp = true;
                this.tenantsShowProp = false;
            },
            loginSuccess(evt) {
                this.loginData = evt;
                this.loginShowProp = false;
                this.tenantsShowProp = true;
            }
        }
    }
</script>

<style>
    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        font-family: Tahoma;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }
    .banner-txt {
        display: block;
        /*vertical-align: bottom;*/
        /*height: 80px;*/
        padding-top: 46px;
    }
    .banner {
        width: 100%;
        padding: 15px;
        background-color: #f6fffc;
        color: #6a6e71;
        font-size: 26px;
        -webkit-box-shadow: 0px 4px 5px 0px rgba(97, 96, 97, 1);
        -moz-box-shadow: 0px 4px 5px 0px rgba(97, 96, 97, 1);
        box-shadow: 0px 4px 5px 0px rgba(97, 96, 97, 1);
    }

    .footer {
        width: 100%;
        height: 350px;
        padding: 15px;
        background-color: #242E38;
        color: aliceblue;
        font-size: 12px;

        -webkit-box-shadow: 0px -4px 5px 0px rgba(97, 96, 97, 1);
        -moz-box-shadow: 0px -4px 5px 0px rgba(97, 96, 97, 1);
        box-shadow: 0px -4px 5px 0px rgba(97, 96, 97, 1);
    }
</style>
